import { mb, mt } from '@upgrade/react-components/Spacing/core';
import styled from 'styled-components';

import Image from '../Image';

export const StyledImage = styled(Image)`
  width: 100%;
  height: auto;
  ${mb('md')}

  @media (min-width: ${props => props.theme.mediaSm}) {
    ${mb('none')}
  }
`;

export const FeatureContainer = styled.div`
  ${mt('md')};

  @media (min-width: ${props => props.theme.mediaSm}) {
    ${mt('xl')}
  }
`;
